import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { take } from 'rxjs/operators';
import { StatusService } from '@app/shared/services/status.service';
import { combineLatest } from 'rxjs';
import { SettingService } from '@app/shared/services/setting.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteSideResolver implements Resolve<unknown> {
  constructor(
    private statusService: StatusService,
    private settingService: SettingService
  ) {}

  resolve() {
    return combineLatest([
      this.statusService.allStatuses$,
      this.settingService.allSettings$
    ]).pipe(
      take(1)
    );
  }
}
